var isStandalone = function () {
    return ("standalone" in window.navigator && window.navigator['standalone']) ||
        (window.navigator.userAgent.toLowerCase().indexOf("android") > -1 && (window.innerHeight / window.screen.height) > 0.9);
};
export default isStandalone;
